import { useCallback, useEffect, useRef } from 'react';

/** Invalidates outstanding work as soon as another document/dialog is rendered. */
export const useDocumentSession = (key: string) => {
  const state = useRef({ key, active: true });
  if (state.current.key !== key) state.current = { key, active: true };
  const session = state.current;
  useEffect(() => {
    session.active = true;
    return () => { session.active = false; };
  }, [session]);
  return useCallback(() => state.current === session && session.active, [session]);
};
